export default "__VITE_ASSET__$_L1y4Me__"